import React from 'react'

import styles from './styles'

const Overlay = ({ children, backgroundContent, images = [] }) => {
  return <div className="overlay-container">
    {backgroundContent}
    <div className="overlay-content">
      <div className="overlay-content-box">
        {children}
      </div>
    </div>

    <style jsx>{styles}</style>
  </div>
}

export default Overlay